import { Link } from '@trashlab/sitesapp/src/organizations/redebins/components/shared/link';

export const WhyProsLove = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-8 italic text-center">
            Why Pros Love RED-E-BINS Dumpsters
          </h2>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Left Column - Image */}
            <div className="flex flex-col items-center">
              <img
                src="/redebins/images/redebins-commercial.jpg"
                alt="Commercial construction dumpster"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <p className="text-[#333333] text-lg italic">Fits Your Project, Your Schedule, and Your Budget.</p>
            </div>

            {/* Right Column - Benefits */}
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#333333] mb-6 italic">
                Small Footprint, <em className="text-[#E31837]">BIG Impact</em>
              </h3>
              <ul className="space-y-4 text-[#333333]">
                <li>
                  <strong>We believe in playing favorites—like giving a general contractor preferred treatment.</strong>
                </li>
                <li>
                  <strong>As a preferred customer, you are eligible to receive discounted pricing, reduced tonnage fees, and extended rental periods for your commercial construction dumpster.</strong>
                  <br />
                  <strong>Bonus: Get our guaranteed same-day delivery & pick-up within 24 hours.</strong>
                </li>
                <li>
                  <strong>
                    Manage your account online to create new orders, request swap-outs and pick-ups, and keep track of all your job invoices.{' '}
                    <Link href="/contact" className="text-[#E31837] hover:underline">
                      Call us
                    </Link>{' '}
                    today to set up a preferred customer account!
                  </strong>
                </li>
                <li>
                  <strong>Price. Service. Reliability. Get your commercial construction dumpster today.</strong>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-8 bg-gray-50 rounded-lg p-6">
            <h3 className="text-xl font-bold text-[#333333] mb-4 italic">
              On Demand. On Time. On Budget.
            </h3>
            <p className="text-[#333333] mb-4">
              <strong>You've got enough to do. So we made our RED-E-BIN ordering system extra-easy, and designed our durable commercial construction dumpsters to fit in the tightest of spaces. Add in competitive pricing and right-now availability, and you're good to go. Start your home repair and remodel with us today!</strong>
            </p>
            <Link
              href="/dumpster-sizes"
              className="inline-block text-[#E31837] hover:underline font-semibold"
            >
              Check out our two dumpster bin sizes &gt;&gt;
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

